import {getMaterialFunction} from "@project/sdk/engineering";
import {GetMaterialFunctionResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {materialFunctionKeys} from "../../../materialFunction-keys";

export function getMaterialFunctionQueryOptions(
  materialFunctionId: string,
  includeDeleted = false,
) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: [...materialFunctionKeys.detail(materialFunctionId), {includeDeleted}] as const,
    queryFn: async ({signal}) =>
      GetMaterialFunctionResponse.parse(
        await getMaterialFunction(materialFunctionId, {includeDeleted}, {signal}),
      ),
  });
}
